import { createI18nText } from '@hilma/netina2all';

const pageNotFoundText = createI18nText({
	he: {
		title: 'אופס! העמוד המבוקש לא נמצא',
		homeBtn: 'לעמוד הבית',
	},
	en: {
		title: 'Oops! This page was not found',
		homeBtn: 'Home',
	}
});

export default pageNotFoundText;